import { routes } from 'router/routes'

export const enabledRoutes = [
  routes.presentHome,
  `${routes.presentHome}*`,
  routes.investingHub.index,
  `${routes.investingHub.index}*`,
  routes.invest.core,
  `${routes.invest.performance}*`,
  routes.later.index,
  `${routes.later.performance}*`,
  `${routes.early.detailsRoute}*`,
  `${routes.early.performanceRoute}*`,
  routes.bankingHub.index,
  `${routes.bankingHub.index}*`,
  routes.grow.index,
  `${routes.grow.topic}*`,
  `${routes.grow.faq}*`,
  `${routes.earn.index}*`,
  routes.earn.interstitial,
  routes.settings.index,
  routes.spend.index,
  routes.emergencyFund.index,
  routes.learn.index,
  routes.invest.tips,
  routes.moneyManager.index,
  routes.financialAdvisor.index,
  routes.emergencyFund.settings,
]
